<template>
  <section class="page-team site-section-v">
    <div class="site-container">
      <ul class="tabs">
        <li
          v-for="(item, index) in teamTypes"
          :key="`team-tab-${item}`"
          @click="selectType(index, item)"
          :class="{ active: currentTab === index }"
        >
          <img src="@/assets/img/svg/icon.svg" width="30" />
          {{ item }}
        </li>
      </ul>
      <transition name="fade" mode="out-in">
        <div class="profile-list" :key="`profile-list-${currentTab}`">
          <profile-card
            v-for="item in profiles"
            :key="`profile-card-${item.id}`"
            :description="item.text"
            :name="item.name"
            :image="item.image"
          >
            <template #footer>
              <p class="text-center">
                <router-link
                  :to="{ name: 'team_detail', params: { slug: item.slug } }"
                  class="button button-orange is-small is-outlined"
                  >VER PERFIL</router-link
                >
              </p>
            </template>
          </profile-card>
        </div>
      </transition>
      <hr />
      <form-contact
        title="Precisa de Ajuda Jurídica?"
        @submit="(data) => submitContact(data)"
      >
        <template #info><contact-info /></template>
      </form-contact>
      <hr />
      <download-app />
    </div>
  </section>
</template>

<script>
import ProfileCard from "@/components/ProfileCard";
import DownloadApp from "@/components/Home/DownloadApp";
import FormContact from "@/components/FormContact";
import ContactInfo from "@/components/ContactInfo";
import api from "../../services/api";

export default {
  components: { ProfileCard, DownloadApp, FormContact, ContactInfo },

  async created() {
    this.selectType(0, "Sócio");
    await this.getTeam();
  },

  data() {
    return {
      currentTab: 0,
      profiles: [],
    };
  },

  computed: {
    teamTypes() {
      return [
        "Sócios",
        // 'Advogados',
        // 'Estagiários',
        // 'Administrativo'
      ];
    },
  },

  methods: {
    async selectType(index) {
      this.currentTab = index;
    },

    async getTeam() {
      const { data: team } = await api.get("team");
      this.profiles = team;
    },

    submitContact() {},
  },
};
</script>

<style>
</style>
